const SVG_SPACE = 'http://www.w3.org/2000/svg';
/**
 * @param {string} printStore
 * @returns {SVGSVGElement}
 */
export function printDataToSVG(printStore) {
  const svg = document.createElementNS(SVG_SPACE, 'svg');
  const elemDatas = printStore.split('#');
  const pageDataString = elemDatas.pop();
  const pageData = pageDataString.split(',');
  const pageElem = document.createElementNS(SVG_SPACE, 'rect');
  const width = parseFloat(pageData[2]);
  const height = parseFloat(pageData[3]);
  pageElem.setAttribute('x', parseFloat(pageData[0]) + '');
  pageElem.setAttribute('y', parseFloat(pageData[1]) + '');
  pageElem.setAttribute('width', width + '');
  pageElem.setAttribute('height', height + '');
  pageElem.id = 'outerPage';
  svg.setAttribute('width', width + 'mm');
  svg.setAttribute('height', height + 'mm');
  svg.setAttribute(
    'viewBox',
    `${pageData[0]} ${pageData[1]} ${width} ${height}`
  );
  svg.appendChild(pageElem);

  if (pageData[4] != undefined) {
    const x = parseFloat(pageData[4]);
    const y = parseFloat(pageData[5]);
    const x2 = width - parseFloat(pageData[6]);
    const y2 = height - parseFloat(pageData[7]);
    const marginnedPage = document.createElementNS(SVG_SPACE, 'path');
    marginnedPage.setAttribute(
      'd',
      `M ${x} ${y} L ${x2} ${y} ${x2} ${y2} ${x} ${y2} Z`
    );
    marginnedPage.id = 'marginnedPage';
    svg.appendChild(marginnedPage);
  }

  while (elemDatas.length) {
    const path = document.createElementNS(SVG_SPACE, 'path');
    path.setAttribute('d', elemDatas.pop());
    svg.appendChild(path);
  }

  return svg;
}
